export default __webpack_public_path__ + "static/media/22.1835799d.jpg";